import React from "react";
import { Grid } from "@mui/material";
import CheckBoxedForDocandSettings from "./CheckBoxedForDocandSettings";
import SmetaTabs from "../../../Tools/Tabs/SmetaTabs";
import { SmetaTabItem } from "../../../Tools/Tabs/PinIcons";
import { createGrid } from "../../../rcsgrid/rcsgrid";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function DocInfoAndSettings({ grid }: { grid: createGrid }) {
  function getLink() {
    let link = window.location.href;
    link += `?modal&parsed&docid=${grid.getActiveSource().getFieldTextSync("ID")}&card`;
    link = link.replace(/secid=[0-9]+&?/gm, "");
    const lastLoginDrx = localStorage.getItem("LastLogin");
    const configName = lastLoginDrx?.split(",")?.[0]?.trim();
    if (configName) {
      link += `&configname=${encodeURIComponent(configName)}`;
    }
    return link;
  }

  return (
    <SmetaTabs id="optionsForUser" style={{ width: "100%", height: "97%" }}>
      <SmetaTabItem
        label={"Информация"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          spacing={3}
          sx={{ mt: 1, overflow: "hidden" }}
        >
          <Grid item>
            {`Время создания: ${grid.getActiveSource().getFieldTextSync("CreateTime")}`}
            <br />
            {`Автор: ${grid.getActiveSource().getFieldTextSync("CreateUser")}`}
          </Grid>
          <Grid item>
            {`Время изменения: ${grid.getActiveSource().getFieldTextSync("UpdateTime")}`}
            <br />
            {`Автор: ${grid.getActiveSource().getFieldTextSync("UpdateUser")}`}
          </Grid>
          <Grid item>
            {`Внутренний код: ${grid.getActiveSource().getFieldTextSync("ID")}  `}
            {`Индекс типа: ${grid.doccfgid ? grid.doccfgid : ""}`}
          </Grid>
          <Grid item>
            <a style={{ cursor: "pointer" }} href={getLink()}>
              Ссылка на документ
            </a>
          </Grid>
        </Grid>
      </SmetaTabItem>
      <SmetaTabItem
        label={"Настройки"}
        style={{
          textTransform: "none",
          width: "100%",
          height: "100%",
          padding: "0px",
          display: "inline-block",
          overflow: "hidden",
        }}
      >
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="flex-start"
          sx={{ mt: 1, overflow: "hidden" }}
        >
          <Grid item>
            <CheckBoxedForDocandSettings />
          </Grid>
          <Grid item></Grid>
          <Grid item></Grid>
        </Grid>
      </SmetaTabItem>
    </SmetaTabs>
  );
}
